<template>
  <div class="flex flex-col items-center space-y-3">
    <img src="./assets/request-error.svg" height="70" width="70" alt="" />
    <h4 class="text-lg font-bold">
      {{ $t('request-form.result.error.title') }}
    </h4>
    <AuiButton type="button" class="w-full" @click="onRetry">
      {{ $t('request-form.result.error.try-again') }}
    </AuiButton>
  </div>
</template>

<script setup lang="ts">
  import { onMounted } from 'vue';
  import { AuiButton } from '@aviata/auiata';

  import { Analytics } from '@shared/analytics';
  import { requestFormConfig } from '../config';

  const emit = defineEmits<{
    onRetry: [];
  }>();

  onMounted(() => {
    Analytics.logEvent({
      event: requestFormConfig.analyticsEvents.SUBMIT.ERROR,
    });
  });

  const onRetry = () => {
    emit('onRetry');

    Analytics.logEvent({
      event: requestFormConfig.analyticsEvents.ERROR_SCREEN.RETRY,
    });
  };
</script>
